import { render, staticRenderFns } from "./PropertyDetail.vue?vue&type=template&id=65612f28&"
import script from "./PropertyDetail.vue?vue&type=script&lang=ts&"
export * from "./PropertyDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports